import React from 'react';
import { useCountUp } from '../../hooks/useCountUp';

/**
 * Muestra un número animado (valor previo → value). Por defecto redondea a
 * entero con separador es-MX; pásale `format` para moneda/%/otro (recibe el
 * valor en curso de la animación). Respeta prefers-reduced-motion.
 */
const CountUp: React.FC<{
  value: number;
  duration?: number;
  format?: (n: number) => string;
  className?: string;
}> = ({ value, duration, format, className }) => {
  const n = useCountUp(value, duration);
  const text = format ? format(n) : Math.round(n).toLocaleString('es-MX');
  return <span className={className}>{text}</span>;
};

export default CountUp;
